import { createSlice } from "@reduxjs/toolkit";

export const routerHistorySlice = createSlice({
  name: "routerHistory",
  initialState: [],
  reducers: {
    addRouterHistory: (state, action) => {
      state.push({...action.payload});
    },
    removeLastRouterHistory: (state) => {
      state.pop();
    },
    updateLastRouterHistory: (state, action) => {
      state.splice(-1, 1, {...action.payload});
    }
  },
});

export const { addRouterHistory, removeLastRouterHistory, updateLastRouterHistory } =
  routerHistorySlice.actions;
export default routerHistorySlice.reducer;
